"use client";
import React from "react";
import { Dropdown } from "flowbite-react";
import { DropdownItem } from "flowbite-react/lib/esm/components/Dropdown/DropdownItem";
import SignOut from "../../services/SignOut";
import { Link } from "react-router-dom";

async function logoutUser() {
  await SignOut();
  localStorage.clear();

  window.location.href = "/";
}

export default function Navbar({ appName, url }) {
  var user = localStorage.getItem("authorized");

  const handleLogout = async (e) => {
    await logoutUser();
  };

  return (
    <>
      <nav className="flex items-center justify-between h-20 px-8 md:px-16 bg-primary-main">
        <div className="container mx-auto flex flex-row justify-between">
          <Link
            to={url}
            className="w-full text-lg md:text-xl font-semibold py-2 text-white"
          >
            {appName}
          </Link>
          <div className="flex flex-row gap-2 items-center justify-end w-1/2 text-white">
            <div className="bg-neutral-300 w-8 h-8 rounded-full grid place-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-8 h-8 text-white"
              >
                <path
                  fillRule="evenodd"
                  d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <Dropdown inline label={user}>
              <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
            </Dropdown>
          </div>
        </div>
      </nav>
    </>
  );
}
